export function encodeB64(str) {
  const encode = encodeURI(str);
  const base64 = btoa(encode);
  return base64;
}
export function isEncodeB64(str) {
  const regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  return regex.test(str);
}
export function decodeB64(base64) {
  const decode = atob(base64);
  const str = decodeURI(decode);
  return str;
}
